import { IconButton } from "@material-ui/core"
import { yellow } from "@material-ui/core/colors"
import { Edit } from "@material-ui/icons"
import { makeStyles } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { openModalActulizarClienteAction } from "../../../ducks/cotizadorDuck"
export const ModalFormClienteStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 5px",
        padding: "10px 10px"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: "600px",
        margin: "0 auto",
        padding: theme.spacing(1),
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "90%",
    },
}))
export const ModalFormClienteUpdate = ({ cliente }) => {
    const dispatch = useDispatch()
    const handleOpen = () => {
        dispatch(openModalActulizarClienteAction({ open: true, cliente, editar: true }))
    }
    return (
        <>
            <IconButton aria-label="delete" onClick={handleOpen}>
                <Edit  style={{ color: yellow[500] }} />
            </IconButton>
        </>
    )
}
export default ModalFormClienteUpdate